import { useCallback } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { Grid, Paper } from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';
import { toast } from 'react-toastify';
import { saveSendingOrder } from 'src/shared/services/sendingService';
import { SendingOrderCreate, SendingOrderCreateSchema } from 'src/modules/sending/models/sendingOrderCreate';
import { FormErrorSummary } from 'src/shared/components/form/formErrorSummary';
import MainContentHeader from 'src/shared/components/atoms/mainContentHeader';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import SendingTypeForm from 'src/modules/sending/components/sendingTypeForm';
import SendingOrderCustomerForm from 'src/modules/sending/components/sendingOrderCustomerForm';
import SendingAttachmentForm from 'src/modules/sending/components/sendingAttachmentForm';
import { FormSummary } from 'src/shared/components/form/formSummary';
import FormStepper from 'src/shared/components/form/formStepper';
import { FormSelectableStateProvider } from 'src/shared/components/form/formSelectableStateContext';
import ConsoleHelper from 'src/shared/functions/consoleHelper';

const SendingOrderCreatePage = () => {
  const formMethods = useForm<SendingOrderCreate>({
    resolver: yupResolver(SendingOrderCreateSchema),
    mode: 'all',
  });

  const {
    handleSubmit,
    formState: { errors },
    trigger,
  } = formMethods;

  const saveFormData = useCallback(async (data) => {
    const result = await saveSendingOrder({ ...data, created: new Date() } as SendingOrderCreate);
    ConsoleHelper.log('result saveSendingOrder', result);
    toast.success('Ny order skapad!', {
      position: 'bottom-left',
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    // handleNext();
  }, []);

  const onSubmit = async (data) => {
    await trigger();
    await saveFormData(data);
  };

  return (
    <FormProvider {...formMethods}>
      <FormSelectableStateProvider>
        <form onSubmit={handleSubmit(onSubmit)}>
          <GridWrapper>
            <Grid item xs={12} md={4} style={{ display: 'flex' }}>
              <MainContentHeader title='Beställ postutskick' />
            </Grid>
            <Grid item xs={12}>
              <Paper
                sx={{
                  p: { xs: 2, sm: 1 },
                }}
              >
                <Grid container>
                  <Grid
                    xs={12}
                    xl={8}
                    sx={{
                      order: { sm: 1, md: 2 },
                    }}
                    item
                  >
                    <FormStepper
                      submitButtonLabel='Spara'
                      formSteps={[
                        {
                          id: 0,
                          label: 'Typ av utskick',
                          stepContent: (
                            <>
                              <SendingTypeForm />
                              <SendingAttachmentForm />
                            </>
                          ),
                        },
                        {
                          id: 1,
                          label: 'Beställare',
                          stepContent: <SendingOrderCustomerForm />,
                        },
                      ]}
                    />
                  </Grid>
                  <Grid
                    xs={12}
                    xl={4}
                    sx={{
                      order: { sm: 1, md: 2 },
                    }}
                    item
                  >
                    <GridWrapper>
                      <Grid xs={12} md={6} xl={12} item>
                        <FormErrorSummary translationNamespace='xxx' errors={errors} />
                      </Grid>
                      <Grid xs={12} md={6} xl={12} item>
                        <FormSummary
                          formSummaryList={[
                            {
                              label: 'Typ av utskick',
                              fieldName: 'product_id',
                            },
                            {
                              label: 'Urvalsbeskrivning',
                              fieldName: 'selectionDescription',
                            },
                            {
                              label: 'Kund, beställare',
                              fieldName: 'customer',
                            },
                            {
                              label: 'Färg',
                              fieldName: 'color',
                            },
                            {
                              label: 'Utskicksdatum',
                              fieldName: 'date_id',
                            },
                            {
                              label: 'Beställare, ditt namn',
                              fieldName: 'createdByName',
                            },
                            {
                              label: 'Beställare, din e-post',
                              fieldName: 'createdByEmail',
                            },
                            {
                              label: 'Övriga önskemål',
                              fieldName: 'message',
                            },
                          ]}
                        />
                      </Grid>
                    </GridWrapper>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </GridWrapper>
        </form>
      </FormSelectableStateProvider>
    </FormProvider>
  );
};

export default SendingOrderCreatePage;
